import type { ReactElement } from 'react';
import { Fragment } from 'react';

import type { ISingleHistoryBet, ISingleHistoryGame } from '../../../../../../api/fetchers/history/types';
import { CurrencyConnected } from '../../../../../currency/CurrencyConnected';
import { L12nText } from '../../../../../text/L12nText';
import styles from '../../HistoryBetInfo.module.css';

import { BingoCard } from './card/BingoCard';

interface IBingoCardProps {
  bets: ISingleHistoryBet[];
  game: ISingleHistoryGame;
}

interface BingoMultiplierEvent {
  bingoMultiplier: {
    numbersAndMultipliers: Record<string, number>;
  };
}

interface BingoGameEvents {
  event: string[];
}

export default function BingoTableResult({ bets, game }: IBingoCardProps): ReactElement {
  const multipliers = (game.additional.bingoGameEvents as BingoGameEvents).event
    .filter((str: string) => ~str.indexOf('"MULTIPLIER"'))
    // eslint-disable-next-line prettier/prettier
    .map<BingoMultiplierEvent>((str: string) => JSON.parse(str))[0].bingoMultiplier.numbersAndMultipliers;

  return (
    <>
      <thead>
        <tr>
          <td className={styles.table_head}>
            <L12nText tk="BETTYPE" />
          </td>
          <th className={styles.table_head}>
            <L12nText tk="BET_LABEL" />
          </th>
          <th className={styles.table_head}>
            <L12nText tk="NETCASH" />
          </th>
        </tr>
      </thead>
      <tbody>
        {bets.map((bet: ISingleHistoryBet, index: number) => {
          const parsed = JSON.parse(bet.description);
          return (
            <Fragment key={index}>
              <tr>
                <td>
                  <L12nText tk="VB_TICKET" /> {parsed.cardNo}
                </td>
                <td>
                  <CurrencyConnected value={Number(bet.amount)} />
                </td>
                <td className={Number(bet.netCash) > 0 ? styles.win : styles.lose}>
                  {game.cancelled && Number(bet.netCash) == 0 ? (
                    <span className={styles.refunded}>
                      <L12nText tk="REFUNDED" />
                    </span>
                  ) : (
                    <CurrencyConnected value={Number(bet.netCash)} />
                  )}
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <BingoCard info={parsed} multipliers={multipliers} />
                </td>
              </tr>
            </Fragment>
          );
        })}
      </tbody>
    </>
  );
}
